import * as storage from './localStorage'

export function init() {
    return new Promise(async (resolve) => {
        await storage.init();
        resolve();
    })
}

// ===== Start Config File =====

// Config ShowError
export function saveConfigShowError(value) {
    storage.saveConfigShowError(value);
}

export function destroyConfigShowError() {
    storage.destroyConfigShowError();
}

export function getConfigShowError() {
    return storage.getConfigShowError();
}

// Config Token_ValidateMinutesInterval
export function saveConfigValidateMinutesInterval(value) {
    storage.saveConfigValidateMinutesInterval(value);
}

export function destroyConfigValidateMinutesInterval() {
    storage.destroyConfigValidateMinutesInterval();
}

export function getConfigValidateMinutesInterval() {
    return storage.getConfigValidateMinutesInterval();
}

// Config Token_RenewMinutes
export function saveConfigRenewMinutes(value) {
    storage.saveConfigRenewMinutes(value);
}

export function destroyConfigRenewMinutes() {
    storage.destroyConfigRenewMinutes();
}

export function getConfigRenewMinutes() {
    return storage.getConfigRenewMinutes();
}

// Config LogInfoDevice
export function saveConfigLogInfoDevice(value) {
    storage.saveConfigLogInfoDevice(value);
}

export function destroyConfigLogInfoDevice() {
    storage.destroyConfigLogInfoDevice();
}

export function getConfigLogInfoDevice() {
    return storage.getConfigLogInfoDevice();
}

// Config EncryptStorage
export function saveConfigEncryptStorage(value) {
    storage.saveConfigEncryptStorage(value);
}

export function destroyConfigEncryptStorage() {
    storage.destroyConfigEncryptStorage();
}

export function getConfigEncryptStorage() {
    return storage.getConfigEncryptStorage();
}

// Config EncryptKey
export function saveConfigEncryptKey(value) {
    storage.saveConfigEncryptKey(value);
}

export function destroyConfigEncryptKey() {
    storage.destroyConfigEncryptKey();
}

export function getConfigEncryptKey() {
    return storage.getConfigEncryptKey();
}

// Config EncryptKeyPassword
export function saveConfigEncryptKeyPassword(value) {
    storage.saveConfigEncryptKeyPassword(value);
}

export function destroyConfigEncryptKeyPassword() {
    storage.destroyConfigEncryptKeyPassword();
}

export function getConfigEncryptKeyPassword() {
    return storage.getConfigEncryptKeyPassword();
}

// Config EntraId_RootBase
export function saveConfigRootBase(value) {
    storage.saveConfigRootBase(value);
}

export function destroyConfigRootBase() {
    storage.destroyConfigRootBase();
}

export function getConfigRootBase() {
    return storage.getConfigRootBase();
}

// Config EntraId_ClientId
export function saveConfigClientId(value) {
    storage.saveConfigClientId(value);
}

export function destroyConfigClientId() {
    storage.destroyConfigClientId();
}

export function getConfigClientId() {
    return storage.getConfigClientId();
}

// Config EntraId_TenantId
export function saveConfigTenantId(value) {
    storage.saveConfigTenantId(value);
}

export function destroyConfigTenantId() {
    storage.destroyConfigTenantId();
}

export function getConfigTenantId() {
    return storage.getConfigTenantId();
}

// Config OnlineHelpFrenchLink
export function saveConfigOnlineHelpFrenchLink(value) {
    storage.saveConfigOnlineHelpFrenchLink(value);
}

export function destroyConfigOnlineHelpFrenchLink() {
    storage.destroyConfigOnlineHelpFrenchLink();
}

export function getConfigOnlineHelpFrenchLink() {
    return storage.getConfigOnlineHelpFrenchLink();
}

// Config OnlineHelpEnglishLink
export function saveConfigOnlineHelpEnglishLink(value) {
    storage.saveConfigOnlineHelpEnglishLink(value);
}

export function destroyConfigOnlineHelpEnglishLink() {
    storage.destroyConfigOnlineHelpEnglishLink();
}

export function getConfigOnlineHelpEnglishLink() {
    return storage.getConfigOnlineHelpEnglishLink();
}

// Config CompanyTitle
export function saveConfigCompanyTitle(value) {
    storage.saveConfigCompanyTitle(value);
}

export function destroyConfigCompanyTitle() {
    storage.destroyConfigCompanyTitle();
}

export function getConfigCompanyTitle() {
    return storage.getConfigCompanyTitle();
}

// Config EntraId_Authority
export function saveConfigAuthority(value) {
    storage.saveConfigAuthority(value);
}

export function destroyConfigAuthority() {
    storage.destroyConfigAuthority();
}

export function getConfigAuthority() {
    return storage.getConfigAuthority();
}

// Config EntraId_RedirectUri
export function saveConfigRedirectUri(value) {
    storage.saveConfigRedirectUri(value);
}

export function destroyConfigRedirectUri() {
    storage.destroyConfigRedirectUri();
}

export function getConfigRedirectUri() {
    return storage.getConfigRedirectUri();
}

// Config EntraId_RedirectLogout
export function saveConfigRedirectLogout(value) {
    storage.saveConfigRedirectLogout(value);;
}

export function destroyConfigRedirectLogout() {
    storage.destroyConfigRedirectLogout();;
}

export function getConfigRedirectLogout() {
    return storage.getConfigRedirectLogout();
}

// Config IntervalWaitSSO
export function saveConfigIntervalWaitSSO(value) {
    storage.saveConfigIntervalWaitSSO(value);;
}

export function destroyConfigIntervalWaitSSO() {
    storage.destroyConfigIntervalWaitSSO();;
}

export function getConfigIntervalWaitSSO() {
    return storage.getConfigIntervalWaitSSO();
}

// ===== End Config File =====


// userCode
export function saveUserCode(value) {
    storage.saveUserCode(value);
}

export function destroyUserCode() {
    storage.destroyUserCode();
}

export function getUserCode() {
    return storage.getUserCode();
}

// userName
export function saveUserName(value) {
    storage.saveUserName(value);
}

export function destroyUserName() {
    storage.destroyUserName();
}

export function getUserName() {
    return storage.getUserName();
}

// employeeId
export function saveEmployeeId(value) {
    storage.saveEmployeeId(value);
}

export function destroyEmployeeId() {
    storage.destroyEmployeeId();
}

export function getEmployeeId() {
    return storage.getEmployeeId();
}


// menu
export function saveMenu(value) {
    storage.saveMenu(value);
}

export function destroyMenu() {
    storage.destroyMenu();
}

export function getMenu() {
    return storage.getMenu();
}


// token
export function saveToken(value) {
    storage.saveToken(value);
}

export function destroyToken() {
    storage.destroyToken();
}

export function getToken() {
    return storage.getToken();
}


// sessionGuid
export function saveSessionGuid(value) {
    storage.saveSessionGuid(value);
}

export function destroySessionGuid() {
    storage.destroySessionGuid();
}

export function getSessionGuid() {
    return storage.getSessionGuid();
}


// abcUsage
export function saveAbcUsage(value) {
    storage.saveAbcUsage(value);
}

export function destroyAbcUsage() {
    storage.destroyAbcUsage();
}

export function getAbcUsage() {
    return storage.getAbcUsage();
}


// linkProjectPActivity
export function saveLinkProjectPActivity(value) {
    storage.saveLinkProjectPActivity(value);
}

export function destroyLinkProjectPActivity() {
    storage.destroyLinkProjectPActivity();
}

export function getLinkProjectPActivity() {
    return storage.getLinkProjectPActivity();
}


//googleApiKey
export function saveGoogleApiKey(value) {
    storage.saveGoogleApiKey(value);
}

export function destroyGoogleApiKey() {
    storage.destroyGoogleApiKey();
}

export function getGoogleApiKey() {
    return storage.getGoogleApiKey();
}


// expenseAccountActivities
export function saveExpenseAccountActivities(value) {
    storage.saveExpenseAccountActivities(value);
}

export function destroyExpenseAccountActivities() {
    storage.destroyExpenseAccountActivities();
}

export function getExpenseAccountActivities() {
    return storage.getExpenseAccountActivities();
}


// language
export function saveLanguage(value) {
    storage.saveLanguage(value);
}

export function destroyLanguage() {
    storage.destroyLanguage();
}

export function getLanguage() {
    return storage.getLanguage();
}

// timesheet
export function saveExpandedTimesheet(value) {
    storage.saveExpandedTimesheet(value);
}

export function destroyExpandedTimesheet() {
    storage.destroyExpandedTimesheet();
}

export function getExpandedTimesheet() {
    return storage.getExpandedTimesheet();
}

// StartDayTimesheet
export function saveStartDayTimesheet(value) {
    storage.saveStartDayTimesheet(value);
}

export function destroyStartDayTimesheet() {
    storage.destroyStartDayTimesheet();
}

export function getStartDayTimesheet() {
    return storage.getStartDayTimesheet();
}

// useTimeTimesheet
export function saveUseTimeTimesheet(value) {
    storage.saveUseTimeTimesheet(value);
}

export function destroyUseTimeTimesheet() {
    storage.destroyUseTimeTimesheet();
}

export function getUseTimeTimesheet() {
    return storage.getUseTimeTimesheet();
}


// useTimeTimesheetRequired
export function saveUseTimeTimesheetRequired(value) {
    storage.saveUseTimeTimesheetRequired(value);
}

export function destroyUseTimeTimesheetRequired() {
    storage.destroyUseTimeTimesheetRequired();
}

export function getUseTimeTimesheetRequired() {
    return storage.getUseTimeTimesheetRequired();
}

// acceptedTermsUse
export function saveAcceptedTermsUse(value) {
    storage.saveAcceptedTermsUse(value);
}

export function destroyAcceptedTermsUse() {
    storage.destroyAcceptedTermsUse();
}

export function getAcceptedTermsUse() {
    return storage.getAcceptedTermsUse();
}

// termsUse
export function saveTermsUse(value) {
    storage.saveTermsUse(value);
}

export function destroyTermsUse() {
    storage.destroyTermsUse();
}

export function getTermsUse() {
    return storage.getTermsUse();
}

// legalInfo
export function saveLegalInfo(value) {
    storage.saveLegalInfo(value);
}

export function destroyLegalInfo() {
    storage.destroyLegalInfo();
}

export function getLegalInfo() {
    return storage.getLegalInfo();
}

// showDateStatementTerms
export function saveShowDateStatementTerms(value) {
    storage.saveShowDateStatementTerms(value);
}

export function destroyShowDateStatementTerms() {
    storage.destroyShowDateStatementTerms();
}

export function getShowDateStatementTerms() {
    return storage.getShowDateStatementTerms();
}

// showDateStatementLegalInfo
export function saveShowDateStatementLegalInfo(value) {
    storage.saveShowDateStatementLegalInfo(value);
}

export function destroyShowDateStatementLegalInfo() {
    storage.destroyShowDateStatementLegalInfo();
}

export function getShowDateStatementLegalInfo() {
    return storage.getShowDateStatementLegalInfo();
}

// scheduleReturnDate
export function saveScheduleReturnDate(value) {
    storage.saveScheduleReturnDate(value);
}

export function destroyScheduleReturnDate() {
    storage.destroyScheduleReturnDate();
}

export function getScheduleReturnDate() {
    return storage.getScheduleReturnDate();
}

// filterRequest
export function saveFilterRequest(value) {
    storage.saveFilterRequest(value);
}

export function destroyFilterRequest() {
    storage.destroyFilterRequest();
}

export function getFilterRequest() {
    return storage.getFilterRequest();
}

// isPasswordComplex
export function saveIsPasswordComplex(value) {
    storage.saveIsPasswordComplex(value);
}

export function destroyIsPasswordComplex() {
    storage.destroyIsPasswordComplex();
}

export function getIsPasswordComplex() {
    return storage.getIsPasswordComplex();
}

// minLengthPassword
export function saveMinLengthPassword(value) {
    storage.saveMinLengthPassword(value);
}

export function destroyMinLengthPassword() {
    storage.destroyMinLengthPassword();
}

export function getMinLengthPassword() {
    return storage.getMinLengthPassword();
}

// clientHashKey
export function saveClientHashKey(value) {
    storage.saveClientHashKey(value);
}

export function destroyClientHashKey() {
    storage.destroyClientHashKey();
}

export function getClientHashKey() {
    return storage.getClientHashKey();
}

// useGeolocation
export function saveUseGeolocation(value) {
    storage.saveUseGeolocation(value);
}

export function destroyUseGeolocation() {
    storage.destroyUseGeolocation();
}

export function getUseGeolocation() {
    return storage.getUseGeolocation();
}

// useGeolocationZone
export function saveUseGeolocationZone(value) {
    storage.saveUseGeolocationZone(value);
}

export function destroyUseGeolocationZone() {
    storage.destroyUseGeolocationZone();
}

export function getUseGeolocationZone() {
    return storage.getUseGeolocationZone();
}

// creditCardSupport
export function saveCreditCardSupport(value) {
    storage.saveCreditCardSupport(value);
}

export function destroyCreditCardSupport() {
    storage.destroyCreditCardSupport();
}

export function getCreditCardSupport() {
    return storage.getCreditCardSupport();
}

// companies
export function saveCompanies(value) {
    storage.saveCompanies(value);
}

export function destroyCompanies() {
    storage.destroyCompanies();
}

export function getCompanies() {
    return storage.getCompanies();
}

// punchTime
export function savePunchTime(value) {
    storage.savePunchTime(value);
}

export function destroyPunchTime() {
    storage.destroyPunchTime();
}

export function getPunchTime() {
    return storage.getPunchTime();
}

// colorCalendar
export function saveColorCalendar(value) {
    storage.saveColorCalendar(value);
}

export function destroyColorCalendar() {
    storage.destroyColorCalendar();
}

export function getColorCalendar() {
    return storage.getColorCalendar();
}

// UseWorkInstructions
export function saveUseWorkInstructions(value) {
    storage.saveUseWorkInstructions(value);
}

export function destroyUseWorkInstructions() {
    storage.destroyUseWorkInstructions();
}

export function getUseWorkInstructions() {
    return storage.getUseWorkInstructions();
}

// DisplayMedicalData
export function saveDisplayMedicalData(value) {
    storage.saveDisplayMedicalData(value);
}

export function destroyDisplayMedicalData() {
    storage.destroyDisplayMedicalData();
}

export function getDisplayMedicalData() {
    return storage.getDisplayMedicalData();
}

// DisplayDistributionSlip
export function saveDisplayDistributionSlip(value) {
    storage.saveDisplayDistributionSlip(value);
}

export function destroyDisplayDistributionSlip() {
    storage.destroyDisplayDistributionSlip();
}

export function getDisplayDistributionSlip() {
    return storage.getDisplayDistributionSlip();
}

// DisplayPreferenceCommunication
export function saveDisplayPreferenceCommunication(value) {
    storage.saveDisplayPreferenceCommunication(value);
}

export function saveDisplayFlagFullTime(value) {
    storage.saveDisplayFlagFullTime(value);
}


export function destroyDisplayPreferenceCommunication() {
    storage.destroyDisplayPreferenceCommunication();
}

export function destroyDisplayFlagFullTime() {
    storage.destroyDisplayFlagFullTime();
}

export function getDisplayPreferenceCommunication() {
    return storage.getDisplayPreferenceCommunication();
}

export function getDisplayFlagFullTime() {
    return storage.getDisplayFlagFullTime();
}

// IsCCQ
export function saveIsCCQ(value) {
    storage.saveIsCCQ(value);
}

export function destroyIsCCQ() {
    storage.destroyIsCCQ();
}

export function getIsCCQ() {
    return storage.getIsCCQ();
}

export function savePartialRequestHoursUsed(value) {
    storage.savePartialRequestHoursUsed(value);
}

export function destroyPartialRequestHoursUsed() {
    storage.destroyPartialRequestHoursUsed();
}

export function getPartialRequestHoursUsed() {
    return storage.getPartialRequestHoursUsed();
}

// ConnectionString
export function saveConnectionString(value) {
    storage.saveConnectionString(value);
}

export function destroyConnectionString() {
    storage.destroyConnectionString();
}

export function getConnectionString() {
    return storage.getConnectionString();
}

// TaxationProvince
export function saveTaxationProvince(value) {
    storage.saveTaxationProvince(value);
}

export function destroyTaxationProvince() {
    storage.destroyTaxationProvince();
}

export function getTaxationProvince() {
    return storage.getTaxationProvince();
}

// FilterExpenseAccount
export function saveFilterExpenseAccount(value) {
    storage.saveFilterExpenseAccount(value);
}

export function destroyFilterExpenseAccount() {
    storage.destroyFilterExpenseAccount();
}

export function getFilterExpenseAccount() {
    return storage.getFilterExpenseAccount();
}

// IsMandatoryPhoneCellPerso
export function saveIsMandatoryPhoneCellPerso(value) {
    storage.saveIsMandatoryPhoneCellPerso(value);
}

export function destroyIsMandatoryPhoneCellPerso() {
    storage.destroyIsMandatoryPhoneCellPerso();
}

export function getIsMandatoryPhoneCellPerso() {
    return storage.getIsMandatoryPhoneCellPerso();
}

// IsMandatoryEmailPerso
export function saveIsMandatoryEmailPerso(value) {
    storage.saveIsMandatoryEmailPerso(value);
}

export function destroyIsMandatoryEmailPerso() {
    storage.destroyIsMandatoryEmailPerso();
}

export function getIsMandatoryEmailPerso() {
    return storage.getIsMandatoryEmailPerso();
}

// IsMandatorySMSPerso
export function saveIsMandatorySMSPerso(value) {
    storage.saveIsMandatorySMSPerso(value);
}

export function destroyIsMandatorySMSPerso() {
    storage.destroyIsMandatorySMSPerso();
}

export function getIsMandatorySMSPerso() {
    return storage.getIsMandatorySMSPerso();
}

// CommunicationPreference
export function saveCommunicationPreference(value) {
    storage.saveCommunicationPreference(value);
}

export function destroyCommunicationPreference() {
    storage.destroyCommunicationPreference();
}

export function getCommunicationPreference() {
    return storage.getCommunicationPreference();
}

// IsDisplayPayAdvanceVacation
export function saveIsDisplayPayAdvanceVacation(value) {
    storage.saveIsDisplayPayAdvanceVacation(value);
}

export function destroyIsDisplayPayAdvanceVacation() {
    storage.destroyIsDisplayPayAdvanceVacation();
}

export function getIsDisplayPayAdvanceVacation() {
    return storage.getIsDisplayPayAdvanceVacation();
}

// IsUsePartialRequest
export function saveIsUsePartialRequest(value) {
    storage.saveIsUsePartialRequest(value);
}

export function destroyIsUsePartialRequest() {
    storage.destroyIsUsePartialRequest();
}

export function getIsUsePartialRequest() {
    return storage.getIsUsePartialRequest();
}

// IsSSO
export function saveIsSSO(value) {
    storage.saveIsSSO(value);
}

export function destroyIsSSO() {
    storage.destroyIsSSO();
}

export function getIsSSO() {
    return storage.getIsSSO();
}

// IsAuthSSO
export function saveIsAuthSSO(value) {
    storage.saveIsAuthSSO(value);
}

export function destroyIsAuthSSO() {
    storage.destroyIsAuthSSO();
}

export function getIsAuthSSO() {
    return storage.getIsAuthSSO();
}

// IsDisplayPayablesHours
export function saveIsDisplayPayablesHours(value) {
    storage.saveIsDisplayPayablesHours(value);
}

export function destroyIsDisplayPayablesHours() {
    storage.destroyIsDisplayPayablesHours();
}

export function getIsDisplayPayablesHours() {
    return storage.getIsDisplayPayablesHours();
}

// IsDisplayPayablesHours
export function saveIsUseMaterialResourceTimesheet(value) {
    storage.saveIsUseMaterialResourceTimesheet(value);
}

export function destroyIsUseMaterialResourceTimesheet() {
    storage.destroyIsUseMaterialResourceTimesheet();
}

export function getIsUseMaterialResourceTimesheet() {
    return storage.getIsUseMaterialResourceTimesheet();
}

// ShowSubscribe
export function saveShowSubscribe(value) {
    storage.saveShowSubscribe(value);
}

export function destroyShowSubscribe() {
    storage.destroyShowSubscribe();
}

export function getShowSubscribe() {
    return storage.getShowSubscribe();
}

// NotificationPublicKey
export function saveNotificationPublicKey(value) {
    storage.saveNotificationPublicKey(value);
}

export function destroyNotificationPublicKey() {
    storage.destroyNotificationPublicKey();
}

export function getNotificationPublicKey() {
    return storage.getNotificationPublicKey();
}

// NotificationPrivateKey
export function saveNotificationPrivateKey(value) {
    storage.saveNotificationPrivateKey(value);
}

export function destroyNotificationPrivateKey() {
    storage.destroyNotificationPrivateKey();
}

export function getNotificationPrivateKey() {
    return storage.getNotificationPrivateKey();
}

// IsNotificationActivate
export function saveIsNotificationActivate(value) {
    storage.saveIsNotificationActivate(value);
}

export function destroyIsNotificationActivate() {
    storage.destroyIsNotificationActivate();
}

export function getIsNotificationActivate() {
    return storage.getIsNotificationActivate();
}

// IsProfileConsultationMode
export function saveIsProfileConsultationMode(value) {
    storage.saveIsProfileConsultationMode(value);
}

export function destroyIsProfileConsultationMode() {
    storage.destroyIsProfileConsultationMode();
}

export function getIsProfileConsultationMode() {
    return storage.getIsProfileConsultationMode();
}

// ListPrefixConnection
export function saveListPrefixConnection(value) {
    storage.saveListPrefixConnection(value);
}

export function destroyListPrefixConnection() {
    storage.destroyListPrefixConnection();
}

export function getListPrefixConnection() {
    return storage.getListPrefixConnection();
}

// IsDisplayBankOthers
export function saveIsDisplayBankOthers(value) {
    storage.saveIsDisplayBankOthers(value);
}

export function destroyIsDisplayBankOthers() {
    storage.destroyIsDisplayBankOthers();
}

export function getIsDisplayBankOthers() {
    return storage.getIsDisplayBankOthers();
}

// IsDisplayBankVacation
export function saveIsDisplayBankVacation(value) {
    storage.saveIsDisplayBankVacation(value);
}

export function destroyIsDisplayBankVacation() {
    storage.destroyIsDisplayBankVacation();
}

export function getIsDisplayBankVacation() {
    return storage.getIsDisplayBankVacation();
}

// UseServiceProvider
export function saveUseServiceProvider(value) {
    storage.saveUseServiceProvider(value);
}

export function destroyUseServiceProvider() {
    storage.destroyUseServiceProvider();
}

export function getUseServiceProvider() {
    return storage.getUseServiceProvider();
}

// useGeolocationMandatory
export function saveUseGeolocationMandatory(value) {
    storage.saveUseGeolocationMandatory(value);
}

export function destroyUseGeolocationMandatory() {
    storage.destroyUseGeolocationMandatory();
}

export function getUseGeolocationMandatory() {
    return storage.getUseGeolocationMandatory();
}
